import { Http } from '@mygpt/app';

export type UploadImageType = 'avatar' | 'original' | 'faq_image';

export interface UploadImageParams {
  fileType: UploadImageType;
  file: File;
  aiId?: string;
}

export interface UploadImage {
  id: string;
  key: string;
  filename: string;
  file_type: UploadImageType;
  url: string;
}

/**
 * 上传图片
 * @param params
 * @returns
 */
export const uploadImageService = (params: UploadImageParams) => {
  const { post } = Http.use();
  const form = new FormData();
  form.append('file_type', params.fileType);
  form.append('file', params.file);
  form.append('ai_id', params.aiId ?? '');
  return post<UploadImage>(`/attachments/images`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
